<template>
  <el-config-provider :locale="elementPlusLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import vi from 'element-plus/es/locale/lang/vi'

import { getAdminLocale, readAdminLocale } from '@/apps/admin/i18n/locale'
import { resolveRouteLocale } from '@/i18n/route-locale'

const { locale } = useI18n()
const route = useRoute()
const portalElementPlusLocales = { zh: zhCn, en, vi }
const elementPlusLocale = computed(() => {
  if (route.meta.appScope === 'admin') {
    return getAdminLocale(locale.value).elementPlusLocale
  }
  return portalElementPlusLocales[locale.value] || zhCn
})

watch(
  () => route.meta.appScope,
  scope => {
    locale.value = resolveRouteLocale(
      scope === 'admin',
      readAdminLocale(),
      localStorage.getItem('preferred-language'),
      localStorage.getItem('locale')
    )
    document.documentElement.lang = locale.value
  },
  { immediate: true }
)
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}
body {
  width: 100vw;
  height: 100vh;
  overflow: hidden !important;
}
</style>
